import { CreateProductBundleInput } from '@features/catalog/models/product-input.models';
import { PreparationSettingsApiInput } from '@shared/ui/preparation-editor/preparation-editor.models';
import {
  mapPreparationEditorValueToApiInput,
  preparationEditorValueFromForm,
} from '@shared/ui/preparation-editor/preparation-editor.utils';

function touchesPreparationFields(input: CreateProductBundleInput): boolean {
  return (
    input.sendToKitchen !== undefined ||
    input.prepRequiresMode !== undefined ||
    input.prepTimeMinutes !== undefined ||
    input.fulfillmentLeadTimeMode !== undefined ||
    input.fulfillmentLeadTimeDays !== undefined ||
    input.fulfillmentReadyTime !== undefined
  );
}

function buildPreparationSettings(input: CreateProductBundleInput): PreparationSettingsApiInput {
  const value = preparationEditorValueFromForm({
    sendToKitchen: input.sendToKitchen ?? false,
    prepRequiresMode: input.prepRequiresMode ?? 'override',
    prepTimeMinutes: input.prepTimeMinutes ?? null,
    fulfillmentLeadTimeMode: input.fulfillmentLeadTimeMode ?? 'inherit',
    fulfillmentLeadTimeDays: input.fulfillmentLeadTimeDays ?? null,
    fulfillmentReadyTime: input.fulfillmentReadyTime ?? null,
  });
  return mapPreparationEditorValueToApiInput(value, { entityKind: 'product' });
}

/** GraphQL `CreateProductBundleInput`: prep va en `preparationSettings`, no en campos sueltos. */
export function mapCreateProductBundleInputToGraphql(
  input: CreateProductBundleInput
): Record<string, unknown> {
  const {
    prepRequiresMode: _prepRequiresMode,
    prepTimeMinutes: _prepTimeMinutes,
    ...rest
  } = input;

  const graphqlInput: Record<string, unknown> = { ...rest };

  if (touchesPreparationFields(input)) {
    graphqlInput['preparationSettings'] = buildPreparationSettings(input);
  }

  return graphqlInput;
}
